import { doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Broadcast } from "../types";

export const getBroadcastDetails = async (
  broadcastId: string,
): Promise<Broadcast> => {
  const docRef = doc(db, "broadcasts", broadcastId);

  const broadcastSnapshot = await getDoc(docRef);
  const data = broadcastSnapshot.data() as Broadcast;

  return {
    ...data,
    id: broadcastSnapshot.id,
  };
};
